import React, { Component } from 'react';
import styled from 'styled-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import ReactModalHeader from '../Modal/ReactModalHeader';
import ReactModalContent from '../Modal/ReactModalContent';

const StyledHeaderText = styled.div`
  font-family: Nimbus Sans Bold;
  font-size: 20px;
  line-height: 26px;
  color: ${tokens.ColorGrey900};
  margin: 0px 0px 16px 0px;
  padding-top: 24px;
  border-top: 1px solid ${tokens.ColorWhite100};
`;

const StyledImage = styled.img`
  margin: 32px 0px 32px 0px;
`;

const StyledContributionType = styled.div`
  line-height: 1.38;
  color: ${tokens.ColorGrey700};
  .header {
    font-family: Nimbus Sans Bold;
    border-bottom: 4px solid ${tokens.ColorBrandBrightBlue};
    margin-bottom: 24px;
    padding-bottom: 8px;
  }
  width: 47%;
  padding-top: 24px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const StyledContributionTypesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const StyledModalContentContainer = styled.div`
  margin: 24px 0px 48px 0px;
`;

const LegalText = styled.div`
  padding-top: 24px;
  font-size: 16px;
  font-style: italic;
  line-height: 22px;
  color: ${tokens.ColorGrey600};
`;

const contributionTypes = [
  {
    header: 'Pretax',
    copy:
      'Your contributions are made with pretax dollars and reduce your taxable income. You pay taxes on contributions and earnings when you withdraw the money.',
  },
  {
    header: 'Roth',
    copy:
      'Your contributions have already been taxed. and your earnings are tax-free if they’re withdrawn at least 5 years after the year of your first Roth contribution and you’re at least 59½, deceased, or completely and permanently disabled. Your plan may not offer this option.',
  },
  {
    header: 'After-Tax',
    copy:
      'Your contributions are taken out of your paycheck after taxes. You will only pay tax on earnings when you make a withdrawal. Your plan may not offer this option.',
  },
  {
    header: 'Catch-Up',
    copy:
      'If you’re 50 or older and you plan to contribute the maximum allowed by the plan, you may also be able to make catch-up contributions. These can be pretax or Roth if available.',
  },
];

class ContributionEducationModal extends Component<any, any> {
  render(): JSX.Element {
    const mq = window.matchMedia('(max-width: 767px)');
    return (
      <React.Fragment>
        <ReactModalHeader modalTitle={'Why we’re suggesting modeling these amounts?'} showClose={true} />
        <ReactModalContent>
          <StyledModalContentContainer>
            We&#39;ve estimated the total retirement plan contribution and retirement age that will help improve your
            chances of achieving your Retirement Income Goal throughout retirement. If you&#39;re enrolled in Auto
            Increase, we account for those annual increases in our calculations. Explore different contribution
            increases and retirement ages to model the impact on your estimates and projections.
            {mq.matches ? (
              <StyledImage
                src={`data:image/svg+xml;base64,${tokens.AssetImageContributionMobile}`}
                alt="contribution"
              />
            ) : (
              <StyledImage src={`data:image/svg+xml;base64,${tokens.AssetImageContribution}`} alt="contribution" />
            )}
            <StyledHeaderText>Contribution Types</StyledHeaderText>
            <div>
              Any suggested contribution modeling increases will default to pretax until you reach the IRS limit and
              then to after-tax if available. If your plan offfers Roth, you can model the impact of Roth changes. There
              are different tax advantages for different kinds of contributions. Make sure you understand all of them.
            </div>
            <StyledContributionTypesContainer>
              {contributionTypes.map((type, i) => {
                return (
                  <StyledContributionType key={i}>
                    <div className="header">{type.header}</div>
                    <div>{type.copy}</div>
                  </StyledContributionType>
                );
              })}
            </StyledContributionTypesContainer>
            <LegalText>
              IRS and/or plan limits may restrict the total amount you can contribute. IRS contribution limits may vary
              each year.
            </LegalText>
          </StyledModalContentContainer>
        </ReactModalContent>
      </React.Fragment>
    );
  }
}

export default ContributionEducationModal;
